export default "__VITE_ASSET__57ebd08d__"